var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nb-btn',_vm._b({staticClass:"reupload-stroke-button",on:{"click":_vm.onClick}},'nb-btn',_vm.BUTTON_PROPS,false),[_vm._v(_vm._s(_vm.MESSAGES.button))])
}
var staticRenderFns = []

export { render, staticRenderFns }